import styled from 'styled-components'
import { toCssHex } from '../../../../../helpers/color/to-css-hex'

const ColorSwatch = styled.div<{ $hex: string }>`
    width: 100%;
    height: 22px;
    border-radius: 4px;
    background: ${props => toCssHex(props.$hex) ?? 'transparent'};
`

export default ColorSwatch
